(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content-custom"] && !window.DesignMode) return;
  try {
    
document.querySelectorAll('details[id^="Details-collapsible_row"]').forEach((el) => {
	new Accordion(el)
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-native"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
		this.headerBounds = {};

		this.setHeaderHeight();

		window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
		};

		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	setHeaderHeight() {
		document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			this.header.classList.add('scrolled-past-header');
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			this.header.classList.remove('scrolled-past-header');
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
	}
}

customElements.define('sticky-header', StickyHeader);

//* Custom header script
const rebuildNavInTwoParts = (navElement, splitValue) => {
	//* Clone the original navElement
	const navClone = navElement.cloneNode(true)
	navElement.classList.add('to_left')
	navClone.classList.add('to_right')

	//* Remove children from the original navElement whose index is greater than splitValue
	const navElementUL = navElement.querySelector('ul')
	Array.from(navElementUL.children).forEach((child, index) => {
		if (index >= splitValue) {
			navElementUL.removeChild(child)
		}
	})

	//* Remove children from the cloned navElement whose index is less than or equal to splitValue
	const navCloneUL = navClone.querySelector('ul')
	Array.from(navCloneUL.children).forEach((child, index) => {
		if (index < splitValue) {
			navCloneUL.removeChild(child)
		}
	})

	//* Append the cloned navElement (with class 'right') after the original navElement
	navElement.parentNode.insertBefore(navClone, navElement.nextSibling)
}

const measureBestDistribution = (navList) => {
	const navListUl = navList.querySelector('ul')
	const textArray = Array.from(navListUl.children).map(li => {
		return li.innerText.trim().replace(/[\n\t]/g, '')
	})

	let bestSplitIndex = 0
	let smallestDifference = Infinity

	for (let i = 1; i < textArray.length; i++) {
		const leftSideLength = textArray.slice(0, i).join('').length
		const rightSideLength = textArray.slice(i).join('').length

		const difference = Math.abs(leftSideLength - rightSideLength)

		if (difference < smallestDifference) {
			smallestDifference = difference
			bestSplitIndex = i
		}
	}
	return bestSplitIndex
}

//* Add negative margin top equivalent of header height to header element next tag
const adjustHeroContainerMargin = (header, mainContent) => {
	const headerHeight = header.offsetHeight+'px'
	mainContent.style.marginTop = `-${headerHeight}`
}

const customNavInit = () => {

	const navElement = document.querySelector('.header__inline-menu')

	if(navElement) {

		//* 1/Centering logo
		//* Split the nav in two parts
		//* Calculate the length of the navigation item list and cut it in half
		const bestSplit = measureBestDistribution(navElement)
		rebuildNavInTwoParts(navElement, bestSplit)
		const headerWrapper = document.querySelector('.header-wrapper')
		headerWrapper.classList.add('nav-split')

		//* 2/ if page has a specific hero section, adjust the margin top of the hero section
		document.addEventListener('DOMContentLoaded', () => {
			const header = document.querySelector('.section-header') //* "Absolute" header element
			const mainContent = document.querySelector('#MainContent')

			//* Remove opacity__none class after a while to avoid FOUC (Flash of Unstyled Content)
			setTimeout(() => {
				headerWrapper.classList.contains('opacity__none') ? headerWrapper.classList.remove('opacity__none') : null
			}, 70)

			//* Define hero types container HERE
			const heroTypeContainer = ['__hero_cover','__image_banner', '__video_banner', '__slideshow_banner']
			// const heroTypeContainer = ['__video_banner', '__slideshow_banner']

			if (header && mainContent && mainContent.firstElementChild) {
				const firstChildId = mainContent.firstElementChild.id
				const isHeroType = heroTypeContainer.some(type => firstChildId.includes(type))

				if (isHeroType) {
					header.classList.add('has_hero')
					adjustHeroContainerMargin(header, mainContent)
					window.addEventListener('resize', () => adjustHeroContainerMargin(header, mainContent))
				}
			}
		})

		//* 3/ Close Tablet/Mobile menu drawer if it is open on resize
		// const menuDrawer = document.querySelector('header-drawer')
		const menuDrawerDetail = document.querySelector('header-drawer details.menu-drawer-container') //* Burger menu
		const menuDrawerSummary = document.querySelector('header-drawer summary.header__icon')
		let hasTriggered = false
		const closeMenuDrawerIfOpenOnResize = () => {
			if (!hasTriggered && window.innerWidth >= 990 && menuDrawerDetail.open) {
				menuDrawerSummary.click()
				hasTriggered = true
			} else if (hasTriggered && window.innerWidth < 990) {
				hasTriggered = false
			}
		}
		window.addEventListener('resize', closeMenuDrawerIfOpenOnResize)

	}
}

customNavInit()



  } catch(e) { console.error(e); }
})();
})();
